import React, { useEffect, useState } from "react";
import { headerDateTable, mock, inputs } from "./util"
import {
    Table,
    HeaderRow,
    HeaderCell,
    Input,
    ItemRow,
    ItemCell,
    SwitchDiv,
    SwitchBox,
    SwitchInput,
    SwitchSlider,
    ImageCell,
    ItemCellContainer,
    OptionsImage
} from "./style"
import { TableContainer } from '../style'
import { Tab } from "react-bootstrap";
import pen from '../../../../assets/edit-pen-white.svg'
import editIcon from '../../../../assets/router/edit-pen.svg';
import saveIcon from '../../../../assets/router/save-blue.svg';
import { elements } from "../../../../components/routerModal/vehicleContent/vehicleForm/utils";
import { useOutletContext } from "react-router-dom";
import { RouterOutletType } from "../index2";

interface dateAndTimeTableType {
    onChange?: () => void
}


export interface DateAndTimeInterface {
    initHr: string,
    interval: string,
    return: string,
    end: string
}


const DateAndTimeTable: React.FC<dateAndTimeTableType> = (props) => {
    const [editLine, setEditLine] = useState(-1);


    const [inputData, setInputData] = useState(() => {
        return editLine >= 0
            ? {
                initHr: mock[editLine]?.initHr || '',
                interval: mock[editLine]?.interval || '',
                return: mock[editLine]?.return || '',
                end: mock[editLine]?.end || ''
            }
            : {
                initHr: '00:00',
                interval: '00:00',
                return: '00:00',
                end: '00:00'
            };
    })



    const handleDataChange = (field: string, value: any) => {

        setInputData((prevData) => ({
            ...prevData,
            [field]: value
        }))

    }

    const edit = (id: number) => {
        setEditLine(id)
        // alert("edit " + mock[id].day)
        // alert(editLine)
        setInputData({
            initHr: mock[id].initHr,
            interval: mock[id].interval,
            return: mock[id].return,
            end: mock[id].end
        })
    }
    const save = () => {
        alert(mock[editLine].day + " SALVO! ")
        setEditLine(-1)
        setInputData({
            initHr: '00:00',
            interval: '00:00',
            return: '00:00',
            end: '00:00'
        })
    }
    const { setTabIndex } = useOutletContext<RouterOutletType>()
  
useEffect(() => {
  setTabIndex(3)
}, [])
    return (
        <>
            <TableContainer>
                <Table>
                    <thead>
                        <HeaderRow>
                            {headerDateTable.map((header) => (
                                <HeaderCell key={header}>{header}</HeaderCell>
                            ))}
                        </HeaderRow>
                    </thead>
                    <tbody>
                        {mock.map((dia, index) => (
                            <ItemRow key={dia.id}>
                                <ItemCell key={dia.id}>
                                    <SwitchDiv>
                                        <SwitchBox>
                                            <SwitchInput
                                                type="checkbox"
                                                checked={dia.active} />
                                            <SwitchSlider className="slider"></SwitchSlider>
                                        </SwitchBox>
                                    </SwitchDiv>
                                </ItemCell>

                                <ItemCell key={dia.day}>{dia.day} </ItemCell>

                                {inputs.map((input) => {
                                    return (
                                        <ItemCell key={dia[input.name]}>

                                            {dia.active ?

                                                <Input
                                                    name={input.name || 0}
                                                    onChange={(e) => {
                                                        if (index === editLine) {
                                                            handleDataChange(input.name, e.target.value)
                                                        }
                                                    }}
                                                    placeholder="00:00"
                                                    value={editLine === index ? inputData[input.name] : dia[input.name] || '-'}
                                                />
                                                :
                                                <>-</>
                                            }
                                        </ItemCell>
                                    )
                                })}
                                {dia.active && (
                                    <ImageCell>
                                        <OptionsImage
                                            onClick={() => {
                                                if (editLine !== index) {
                                                    edit(index);
                                                } else {
                                                    save();
                                                }
                                            }}
                                            src={editLine === index ? saveIcon : editIcon}
                                            alt="Icon to edit or save router"
                                        />
                                    </ImageCell>
                                )}

                                
                            </ItemRow>
                        ))}
                    </tbody>
                </Table>
            </TableContainer>
        </>
    )
}

export default DateAndTimeTable